var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.8301V16.5301C19 19.6501 16.09 22.1801 12.5 22.1801C8.91 22.1801 6 19.6501 6 16.5301V12.8301C6 15.9501 8.91 18.1801 12.5 18.1801C16.09 18.1801 19 15.9501 19 12.8301Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.82969C19 8.73969 18.75 9.57968 18.31 10.2997C17.24 12.0597 15.04 13.1797 12.5 13.1797C9.96 13.1797 7.76 12.0597 6.69 10.2997C6.25 9.57968 6 8.73969 6 7.82969C6 6.26969 6.72999 4.85969 7.89999 3.83969C9.07999 2.80969 10.7 2.17969 12.5 2.17969C14.3 2.17969 15.92 2.80969 17.1 3.82969C18.27 4.85969 19 6.26969 19 7.82969Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.82969V12.8297C19 15.9497 16.09 18.1797 12.5 18.1797C8.91 18.1797 6 15.9497 6 12.8297V7.82969C6 4.70969 8.91 2.17969 12.5 2.17969C14.3 2.17969 15.92 2.80969 17.1 3.82969C18.27 4.85969 19 6.26969 19 7.82969Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.9e5013370f2c3146b371bfc3c9a73ad0.svg";
export { ForwardRef as ReactComponent };